import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import ButtonDropdown from './ButtonDropdown';
const SimpleButtonDropdown = (props) => _jsx(ButtonDropdown, Object.assign({}, props, { noCaret: true }));
export default SimpleButtonDropdown;
